import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import News from './news'
import Login from './login'
import Gallery from './gallery'
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs({db, user}) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
console.log(user)
  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
         value={value} 
         onChange={handleChange} 
         aria-label="basic tabs example" 
         centered
         textColor="secondary"
         indicatorColor="secondary">
          <Tab label="News" {...a11yProps(0)} disabled={!(user.read&&user.read.includes("news"))}/>
          <Tab label="Gallary" {...a11yProps(1)} disabled={!(user.read&&user.read.includes("gallary"))}/>
          <Tab label="Logins" {...a11yProps(2)} disabled={!(user.read&&user.read.includes("login"))}/>
        </Tabs>
      </Box>
   { user.read&&user.read.includes("news")?  <TabPanel value={value} index={0}>
        <News db={db} user={user}/>
      </TabPanel>:null}
     {user.read&&user.read.includes("gallary")? <TabPanel value={value} index={1}>
        <Gallery db={db} user={user}/>
      </TabPanel>:null}
      {user.read&&user.read.includes("login")?<TabPanel value={value} index={2}>
        <Login db={db} user={user}/>
      </TabPanel>:null}
    </Box>
  );
}
